
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 16h2.1l6-5.95L9.95 7.9 4 13.85V16zm8.8-6.65l1.05-1.1a.48.48 0 000-.7l-1.4-1.4a.48.48 0 00-.7 0l-1.1 1.05 2.15 2.15zM2 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 010 18V4c0-.55.196-1.02.588-1.413A1.926 1.926 0 012 2h4.2c.217-.6.58-1.083 1.087-1.45A2.857 2.857 0 019 0c.633 0 1.204.183 1.713.55.508.367.87.85 1.087 1.45H16c.55 0 1.02.196 1.413.587C17.803 2.98 18 3.45 18 4v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0116 20H2zM9 3.25a.728.728 0 00.75-.75.728.728 0 00-.75-.75.728.728 0 00-.75.75.728.728 0 00.75.75z"}})])
          )
        }
      }
    